var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import React, { useEffect, useState } from 'react';
import { MuiStack } from '../atoms/stackComponent';
import moment from 'moment';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { MuiIconButton } from '../atoms/iconButtonComponent';
import { ChevronLeft, ChevronRight, ColoredChevronRight } from '../../assets/images';
import { Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';
import { MuiButton } from '../atoms/buttonComponent';
import './calendar.css';
import { groupBy } from "lodash";
import ListCard from '../../modules/commonViews/list/listCard';
import { MuiPopup } from '../molecules/popupComponent';
var getToggleView = ['Day', 'Week'];
function CalendarGridComponent(props) {
    var eventsList = props.eventsList, resourceData = props.resourceData, moduleName = props.moduleName, handleClick = props.handleClick, handleClickViewDetails = props.handleClickViewDetails, totalCount = props.totalCount;
    var localizer = momentLocalizer(moment);
    var _a = useState(resourceData), resources = _a[0], setResources = _a[1];
    var _b = useState(), activeView = _b[0], setActiveView = _b[1];
    var _c = useState('Day'), selectedToggleView = _c[0], setselectedToggleView = _c[1];
    var _d = useState(new Date()), getDate = _d[0], setDate = _d[1];
    var _e = useState(moment().month()), currentMonth = _e[0], setCurrentMonth = _e[1];
    var _f = useState(Views.DAY), currentView = _f[0], setCurrentView = _f[1];
    var _g = useState(null), eveIndex = _g[0], setEveIndex = _g[1];
    var _h = useState(null), selectedEvent = _h[0], setSelectedEvent = _h[1];
    var _j = useState(0), totalCountNew = _j[0], setTotalCountNew = _j[1];
    // const [isOpen, setIsOpen] = useState<any>(false)
    var _k = useState({}), dialogData = _k[0], setDialogData = _k[1];
    var _l = useState(null), anchorEl = _l[0], setAnchorEl = _l[1];
    var open = Boolean(anchorEl);
    // Calculate the total count based on the selected toggle view
    var calculateTotalCount = function () {
        var start = moment(getDate).startOf(selectedToggleView.toLowerCase()).toISOString();
        var end = moment(getDate).endOf(selectedToggleView.toLowerCase()).toISOString();
        var filteredEvents = eventsList === null || eventsList === void 0 ? void 0 : eventsList.filter(function (event) {
            var eventStart = moment(event.start).toISOString();
            return moment(eventStart).isBetween(start, end, 'day', '[]');
        });
        return filteredEvents ? filteredEvents.length : 0;
    };
    useEffect(function () {
        var count = calculateTotalCount();
        setTotalCountNew(count);
    }, [selectedToggleView, getDate, eventsList]);
    useEffect(function () {
        // Update events based on the current view
        // switch (selectedToggleView) {
        //   case "Day":
        //     setEventList([...data])
        //     break;
        //   case "Week":
        //     setEventList(data)
        //     break;
        //   case "Month":
        //     // setEventList(test())
        //     setEventList(data)
        //     break;
        //   default:
        //     setEventList(test())
        // }
    }, [selectedToggleView]);
    function test() {
        var dataSource = __spreadArray([], eventsList, true);
        console.log("dataSource -----------------", dataSource);
        var gourpByTitleArray = groupBy(dataSource, "start");
        var result = [];
        for (var _i = 0, _a = Object.entries(gourpByTitleArray); _i < _a.length; _i++) {
            var _b = _a[_i], resourceId = _b[0], events = _b[1];
            var groupByResource = groupBy(events, "resourceId");
            for (var _c = 0, _d = Object.entries(groupByResource); _c < _d.length; _c++) {
                var _e = _d[_c], resourceId_1 = _e[0], eventItems = _e[1];
                var resouceItems = [];
                resouceItems = eventItems;
                if (eventItems.length > 2) {
                    resouceItems = __spreadArray(__spreadArray([], eventItems.slice(0, 2), true), [_objectSpread(_objectSpread({}, eventItems[0]), {}, {
                            title: "+more",
                            desc: ""
                        })], false);
                }
                result.push(resouceItems);
            }
        }
        console.log("---*****_____", result.flat());
        return result.flat();
        // const eventsByDateTime = eventsList.reduce(slotEvents) => {
        //   const groupKey = format(anotherEvent.startTime, 'M-d-hh-a');
        //   const existingEvent = slotEvents.get(groupKey);
        //   if (existingEvent) {
        //     existingEvent.resource.sameDateTimeEvents.push(map(anotherEvent));
        //     slotEvents.set(groupKey, existingEvent);
        //   } else {
        //     slotEvents.set(groupKey, map(anotherEvent));
        //   }
        //   return slotEvents;
        // }, emptyMap);
    }
    var formateDdMm = function (item) {
        if (item < 10) {
            return "0".concat(item);
        }
        else {
            return item;
        }
    };
    var dateFormate = function (date, selectedToggleView) {
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var objectDate = new Date(date);
        var d = objectDate.getDate();
        var month = monthNames[objectDate.getMonth()];
        var y = objectDate.getFullYear();
        var dd = formateDdMm(d);
        if (selectedToggleView == 'Day') {
            return "".concat(month, " ").concat(dd, ", ").concat(y);
        }
        else {
            return "".concat(month, ", ").concat(y);
        }
    };
    function CustomToolbar(toolbar) {
        var toolbarDate = toolbar.date;
        var goToCurrent = function () {
            var now = new Date();
            props.hanleMonthToggle(moment(now).startOf("day").toISOString(), moment(now).startOf("day").toISOString());
            toolbarDate.setDate(now.getDate());
            toolbarDate.setMonth(now.getMonth());
            toolbarDate.setYear(now.getFullYear());
            toolbar.onNavigate('current', now);
            var count = calculateTotalCount();
            setTotalCountNew(count);
        };
        var goToBack = function () {
            var view = selectedToggleView.toLowerCase();
            var newDate;
            if (view === "month") {
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth() - 1, 1);
                props.hanleMonthToggle(moment(newDate).startOf('month').toISOString(), moment(newDate).endOf('month').toISOString());
            }
            else if (view === "week") {
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth(), toolbarDate.getDate() - 7, 1);
                props.hanleMonthToggle(moment(newDate).startOf('week').toISOString(), moment(newDate).endOf('week').toISOString());
            }
            else {
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth(), toolbarDate.getDate() - 1, 1);
                props.hanleMonthToggle(moment(newDate).startOf('day').toISOString(), moment(newDate).startOf('day').toISOString());
            }
            toolbar.onNavigate("prev", newDate);
        };
        var goToNext = function () {
            var view = selectedToggleView.toLowerCase();
            var newDate;
            if (view === "month") {
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth() + 1, 1);
                props.hanleMonthToggle(moment(newDate).startOf('month').toISOString(), moment(newDate).endOf('month').toISOString());
            }
            else if (view === "week") {
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth(), toolbarDate.getDate() + 7, 1);
                props.hanleMonthToggle(moment(newDate).startOf('week').toISOString(), moment(newDate).endOf('week').toISOString());
            }
            else {
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth(), toolbarDate.getDate() + 1, 1);
                props.hanleMonthToggle(moment(newDate).startOf('day').toISOString(), moment(newDate).startOf('day').toISOString());
            }
            toolbar.onNavigate("next", newDate);
        };
        var handleToggle = function (view) {
            setselectedToggleView(view);
            setCurrentView(view);
            var newDate;
            if (view.toLowerCase() === 'day') {
                toolbar.onView('day');
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth(), toolbarDate.getDate(), 1);
                props.hanleMonthToggle(moment(newDate).startOf('day').toISOString(), moment(newDate).endOf('day').toISOString());
            }
            else if (view.toLowerCase() === 'week') {
                toolbar.onView('week');
                newDate = new Date(toolbarDate.getFullYear(), toolbarDate.getMonth(), toolbarDate.getDate(), 1);
                props.hanleMonthToggle(moment(newDate).startOf('week').toISOString(), moment(newDate).endOf('week').toISOString());
            }
            else if (view.toLowerCase() === 'month') {
                toolbar.onView('month');
            }
            toolbar.onNavigate("next", newDate);
        };
        setDate(toolbar.date);
        return /*#__PURE__*/ React.createElement(MuiStack, {
            padding: 3,
            style: {
                flexDirection: 'row',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, null, ['day'].includes(selectedToggleView.toLowerCase()) && /*#__PURE__*/ React.createElement(MuiButton, {
            name: "Today",
            size: "medium"
            //fullWidth 
            ,
            variant: "outlined",
            style: {
                display: 'flex',
                borderRadius: '8px',
                border: '1px solid #DEE4EB',
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                padding: '10px 14px',
                alignItems: 'center',
                color: '#6A7682',
                fontSize: '14px',
                fontWeight: '500'
            },
            onClick: goToCurrent
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'center',
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "more-menu-icon",
            style: {
                height: '24px',
                width: '24px',
                marginLeft: '10px'
            },
            onClick: goToBack
        }, /*#__PURE__*/ React.createElement("img", {
            id: "moreMenuIcon",
            src: ChevronLeft,
            alt: "settingIcon"
        })), /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "more-menu-icon",
            style: {
                height: '24px',
                width: '24px',
                marginLeft: '10px'
            },
            onClick: goToNext
        }, /*#__PURE__*/ React.createElement("img", {
            id: "moreMenuIcon",
            src: ChevronRight,
            alt: "settingIcon"
        })), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h2",
            style: {
                marginLeft: '10px',
                color: '#1B1D21'
            }
        }, dateFormate(getDate, selectedToggleView)))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
            style: {
                display: 'flex',
                padding: '5px 10px',
                alignItems: 'center',
                borderRadius: '8px',
                backgroundColor: '#EFF2F5'
            }
        }, getToggleView.map(function (item, index) {
            var isActive = selectedToggleView === item;
            return /*#__PURE__*/ React.createElement(MuiStack, {
                style: {
                    padding: '5px',
                    backgroundColor: isActive ? '#ffffff' : '#EFF2F5',
                    borderRadius: '4px'
                },
                onClick: function () { return handleToggle(item); }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                color: isActive ? '#1B1D21' : '#6A7682',
                sx: {
                    cursor: 'pointer'
                }
            }, item));
        }))), /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'center',
            alignItems: "center",
            marginLeft: '10px'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h2",
            color: '#1B1D21'
        }, totalCountNew !== null && totalCountNew !== void 0 ? totalCountNew : 0), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            color: '#8593A3',
            flexWrap: 'wrap',
            marginLeft: "5px"
        }, t('total appointments')))));
    }
    var handleClickEvent = function (e, event) {
        e.stopPropagation();
        console.log('e.currentTarget 1', e);
        console.log('e.currentTarget 2', e.currentTarget);
        setAnchorEl(e.currentTarget);
        setDialogData(event);
    };
    function MonthEventComponent(_ref) {
        var event = _ref.event;
        return (
        /*#__PURE__*/
        // <div style={{ backgroundColor: 'lightgreen', padding: '5px' }}>
        //   <strong>{event.title}</strong>
        // </div>
        React.createElement(MuiStack, {
            spacing: 2
            // marginY={1}
            ,
            marginLeft: 0.5,
            paddingLeft: 0.5,
            justifyContent: "flex-start",
            style: {
                borderRadius: '0px 4px 4px 0px',
                backgroundColor: '#F4F7FA',
                borderLeft: '2px solid #3697FF',
                alignItems: 'center',
                height: '100%'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            title: ''
        }, /*#__PURE__*/ React.createElement(Typography, {
            noWrap: true,
            sx: {
                maxWidth: 100
            },
            variant: "subtitle2",
            color: '#1B1D21'
        }, event === null || event === void 0 ? void 0 : event.title)), /*#__PURE__*/ React.createElement(Tooltip, {
            title: ''
        }, /*#__PURE__*/ React.createElement(Typography, {
            noWrap: true,
            sx: {
                maxWidth: 100
            },
            variant: "subtitle2",
            color: '#8593A3'
        }, event === null || event === void 0 ? void 0 : event.desc)), /*#__PURE__*/ React.createElement(MuiIconButton, {
            onClick: function (e) {
                handleClickEvent(e, event);
                setSelectedEvent(event);
                console.log('I AM ARROW BUTTON CLICK', event);
            }
            // onClick={(e) => {
            //   e.stopPropagation();
            //   console.log('e.currentTarget 1', e)
            //   console.log('e.currentTarget 2', e.currentTarget)
            //   setAnchorEl(e.currentTarget);
            //   setDialogData(event)
            // }}
            ,
            id: "more-menu-icon",
            style: {
                height: '24px',
                width: '24px'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            id: "moreMenuIcon",
            src: ColoredChevronRight,
            alt: "settingIcon"
        })))));
    }
    ;
    function DayEventComponent(_ref2) {
        var event = _ref2.event;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 2
            // marginY={1}
            ,
            marginLeft: 0.5,
            paddingLeft: 0.5,
            justifyContent: "flex-start",
            style: {
                borderRadius: '0px 4px 4px 0px',
                backgroundColor: '#F4F7FA',
                borderLeft: '2px solid #3697FF',
                alignItems: 'center',
                // width: 'fit-content',
                height: '100%',
                justifyContent: 'space-between'
            },
            onClick: function (e) {
                handleClickEvent(e, event);
                setSelectedEvent(event);
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                direction: 'row'
            }
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            title: ''
        }, /*#__PURE__*/ React.createElement(Typography, {
            noWrap: true,
            sx: {
                maxWidth: 70
            },
            variant: "subtitle2",
            color: '#1B1D21'
        }, event === null || event === void 0 ? void 0 : event.title)), /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                marginLeft: '10px'
            },
            variant: "subtitle2",
            color: '#8593A3'
        }, event === null || event === void 0 ? void 0 : event.desc)), /*#__PURE__*/ React.createElement(MuiIconButton, {
            onClick: function (e) {
                // handleClick(e, event)
                handleClickEvent(e, event);
                setSelectedEvent(event);
            }
            // onClick={(e) => {
            //   setAnchorEl(e.currentTarget);
            //   setDialogData(event)
            // }}
            ,
            id: "more-menu-icon",
            style: {
                height: '24px',
                width: '24px'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            id: "moreMenuIcon",
            src: ColoredChevronRight,
            alt: "settingIcon"
        })));
    }
    ;
    function WeekEventComponent(_ref3) {
        var event = _ref3.event;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 2,
            marginLeft: 0.5,
            paddingLeft: 0.5,
            justifyContent: "flex-start",
            style: {
                borderRadius: '0px 4px 4px 0px',
                backgroundColor: '#F4F7FA',
                borderLeft: '2px solid #3697FF',
                alignItems: 'center',
                height: '100%',
                justifyContent: 'space-between'
            },
            onClick: function (e) {
                handleClickEvent(e, event);
                setSelectedEvent(event);
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            title: ''
        }, /*#__PURE__*/ React.createElement(Typography, {
            noWrap: true,
            sx: {
                maxWidth: 70
            },
            variant: "subtitle2",
            color: '#1B1D21'
        }, event === null || event === void 0 ? void 0 : event.title)), /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: '#8593A3'
        }, event === null || event === void 0 ? void 0 : event.desc)), /*#__PURE__*/ React.createElement(MuiIconButton, {
            onClick: function (e) {
                handleClickEvent(e, event);
                setSelectedEvent(event);
            },
            id: "more-menu-icon",
            style: {
                height: '24px',
                width: '24px'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            id: "moreMenuIcon",
            src: ColoredChevronRight,
            alt: "settingIcon"
        })));
    }
    ;
    var formatEventLabel = function (_ref4) {
        var moreEventsCount = _ref4.moreEventsCount;
        return "+".concat(moreEventsCount, " more");
    };
    // Custom day slot wrapper to handle multiple events
    var CustomDaySlotWrapper = function (_ref5) {
        var event = _ref5.event;
        var start = event.start, end = event.end, title = event.title, desc = event.desc, resourceId = event.resourceId;
        var eventsForDate = eventsList.filter(function (evt) { return evt.start === start && evt.resourceId === resourceId; });
        var displayedEvents = eventsForDate.slice(0, 2);
        var remainingEvents = eventsForDate.length - displayedEvents.length;
        return /*#__PURE__*/ React.createElement("div", null, displayedEvents.map(function (event, index) { /*#__PURE__*/ return React.createElement(DayEventComponent, {
            key: index,
            event: event
        }); }), remainingEvents > 0 && /*#__PURE__*/ React.createElement(DayEventComponent, {
            event: {
                title: '+more',
                events: eventsForDate.slice(2)
            }
        }));
    };
    function Event(_ref6) {
        var event = _ref6.event;
        console.log('event^^^^^', event);
        return /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 2
            // marginY={1}
            ,
            marginLeft: 0.5,
            paddingLeft: 0.5,
            justifyContent: "flex-start",
            style: {
                borderRadius: '0px 4px 4px 0px',
                backgroundColor: '#F4F7FA',
                borderLeft: '2px solid #3697FF',
                alignItems: 'center',
                width: 'fit-content',
                height: '100%'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            title: ''
        }, /*#__PURE__*/ React.createElement(Typography, {
            noWrap: true,
            sx: {
                maxWidth: 70
            },
            variant: "subtitle2",
            color: '#1B1D21'
        }, event === null || event === void 0 ? void 0 : event.title)), /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: '#8593A3'
        }, event === null || event === void 0 ? void 0 : event.desc)), /*#__PURE__*/ React.createElement(MuiIconButton, {
            onClick: function (e) {
                handleClick(e, event);
            }
            // onClick={(e) => {
            //   setAnchorEl(e.currentTarget);
            //   setDialogData(event)
            // }}
            ,
            id: "more-menu-icon",
            style: {
                height: '24px',
                width: '24px'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            id: "moreMenuIcon",
            src: ColoredChevronRight,
            alt: "settingIcon"
        })));
    }
    var customDayPropGetter = function (date) {
        return {
            style: {
            // minHeight: '100px',
            // height:'200px',
            // width:'400px'
            }
        };
    };
    var customSlotPropGetter = function (date) {
        return {
            style: {
            // minHeight: '100px',
            // height:'200px',
            // width:'fit-content'
            }
        };
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var eventGetter = function (_ref7) {
        var event = _ref7.event;
        return _objectSpread(_objectSpread({}, event), {}, {
            title: event === null || event === void 0 ? void 0 : event.title
        });
    };
    var findByIndex = function () {
        var index = eventsList.findIndex(function (obj) { return obj.AppointmentId === selectedEvent.AppointmentId; });
        return index;
    };
    // Function to calculate step based on the first event's SlotStartTime and SlotEndTime
    var calculateStepFromFirstEvent = function (events) {
        if (!events || events.length === 0)
            return 120; // fallback
        var first = events[0];
        var start = new Date(first.SlotStartTime);
        var end = new Date(first.SlotEndTime);
        var diff = Math.abs(end.getTime() - start.getTime());
        var stepInMinutes = Math.max(15, Math.floor(diff / (1000 * 60)));
        return stepInMinutes;
    };
    var calculatedStep = calculateStepFromFirstEvent(eventsList);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Calendar, {
        popup: true,
        localizer: localizer,
        events: eventsList ? eventsList : [],
        defaultView: Views.DAY,
        defaultDate: new Date()
        // resources={resources}
        ,
        startAccessor: "start",
        endAccessor: "end",
        toolbar: true,
        step: calculatedStep,
        timeslots: 1,
        views: {
            day: true,
            week: true,
            month: true
        },
        min: new Date(2017, 10, 0, 7, 0, 0),
        max: new Date(2017, 10, 0, 19, 0, 0),
        eventPropGetter: eventGetter,
        dayPropGetter: customDayPropGetter,
        slotPropGetter: customSlotPropGetter,
        components: {
            month: {
                event: MonthEventComponent
            },
            day: {
                event: DayEventComponent
            },
            week: {
                event: WeekEventComponent
            },
            // eventWrapper: CustomDaySlotWrapper,
            toolbar: CustomToolbar
        },
        style: {
            width: '100%',
            height: '100%',
            border: '1px solid #DEE4EB',
            borderRadius: '12px',
            fontFamily: 'NotoSans-Regular'
        },
        dayLayoutAlgorithm: 'no-overlap'
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        containerStyle: {
            width: '450px'
        },
        openPopup: open,
        onClose: handleClose,
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(ListCard, {
        data: selectedEvent,
        isMoreMenuVisible: true,
        parentComponent: moduleName
        // menusFeatures={menusFeatures}
        ,
        handleClick: function (event) {
            handleClick(event, findByIndex(), selectedEvent);
        },
        onCardClick: function () {
            handleClickViewDetails(selectedEvent);
        },
        showViewDetailsButton: true
    })));
}
export default CalendarGridComponent;
